export const API_BASE =
  // "https://insoluble-unseparately-delena.ngrok-free.dev/api";
  "https://hrm.sportstech.team/api";

// "https://stelar-herbert-sinlike.ngrok-free.dev/api";
